import type { IAvatarValue } from './AvatarPicker';

export async function avatarUploadFile(
  avatar: IAvatarValue,
): Promise<File | null> {
  if (avatar.file) return avatar.file;
  if (!avatar.src || /^https?:\/\//i.test(avatar.src)) return null;

  const response = await fetch(avatar.src);
  if (!response.ok) throw new Error('Avatar file was not loaded');
  const blob = await response.blob();
  const type = blob.type || 'image/svg+xml';
  const extension = type.includes('svg') ? 'svg' : type.split('/')[1] || 'img';
  return new File([blob], `avatar.${extension}`, { type });
}

export function profileAvatarFormData(
  profile: object,
  categoryIds: number[],
  file: File,
  category: IAvatarValue['type'],
): FormData {
  const formData = new FormData();
  formData.append('profile', JSON.stringify(profile));
  formData.append('categoryIds', JSON.stringify(categoryIds));
  formData.append('avatar', file);
  formData.append('category', category);
  return formData;
}
